import "./Corporateoffice.css";
import { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function Corporateoffice() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.corporateoffice;

  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <div>
      <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      <div class="container-fluid Corporate bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "9000px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Business Hub
          </h4>
        </div>
      </div>

      {/* <!-- Header End -->
    
        <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      {/* <!-- Contact Start --> */}
      <div class="container-fluid innercontain  contact-2 py-5">
        <div class="container">
          <div className="container mob_pt">
            <div
              class="text-left job_search_sec  d-flex mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="col-8 p-4">
                <h1 className="display-3 text-white mb-3">
                  KTIG Group of Company
                </h1>
                <p className="">
                  Our philosophy is very simple - hire a team devisers,
                  passionate people and foster a cultural empowers you to do
                  your best work.
                </p>
              </div>
            </div>

            <div className="company_openings corporate">
              <div className="row gx-0 gy-4 ">
                <div
                  class="col-lg-6 career_jobinteam col-xl-6"
                  data-wow-delay="0.3s"
                >
                  <div className="d-flex">
                    <div className="ps-4">
                      <div className="service-btn text-center p-3">
                        <p className="text-white mb-0">STONE</p>
                        <h3 className="text-white stonenum">1</h3>
                      </div>
                    </div>
                    <div class="service-content p-3 pt-0 text-start">
                      <a href="#" class="h6 d-inline-block text-white mb-3">
                        Kovai Tech Nidhi Limited
                      </a>
                      <p className="text-white mb-0">
                        53-2, Second Floor, MKP Colony Main St, Ganapathy,
                        Coimbatore, Tamil Nadu-641006.
                      </p>
                      <p className="text-white mb-0">
                        support@kovaitechnidhi.com
                      </p>
                      <p className="text-white mb-0">
                        Help Desk: 0422-4379977 <br />
                        Support: +91 9600414760
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-6 career_jobinteam col-xl-6"
                  data-wow-delay="0.3s"
                >
                  <div className="d-flex">
                    <div className="ps-4">
                      <div className="service-btn text-center p-3">
                        <p className="text-white mb-0">STONE</p>
                        <h3 className="text-white stonenum">2</h3>
                      </div>
                    </div>
                    <div class="service-content p-3 pt-0  text-start">
                      <a href="#" class="h6 d-inline-block text-white mb-3">
                        BR Academy Private Limited
                      </a>
                      <p className="text-white mb-0">
                        53-3, Third Floor, MKP Colony Main St, Ganapathy,
                        Coimbatore, Tamil Nadu-641006.
                      </p>
                      <p className="text-white mb-0">info@bracadmy.com</p>
                      <p className="text-white mb-0">
                        Office: 0422 4512662 <br />
                        Enquiry: +91 9952049494
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="col-lg-6 career_jobinteam col-xl-6"
                  data-wow-delay="0.3s"
                >
                  <div className="d-flex">
                    <div className="ps-4">
                      <div className="service-btn text-center p-3">
                        <p className="text-white mb-0">STONE</p>
                        <h3 className="text-white stonenum">3</h3>
                      </div>
                    </div>
                    <div class="service-content p-3 pt-0  text-start">
                      <a href="#" class="h6 d-inline-block text-white mb-3">
                        Kovai Tech Member Chamber
                      </a>
                      <p className="text-white mb-0">
                        53-2, Second Floor, MKP Colony Main St, Ganapathy,
                        Coimbatore, Tamil Nadu-641006.
                      </p>
                      <p className="text-white mb-0">info@ktig.co.in</p>
                      <p className="text-white mb-0">
                        Help Desk: 0422-4379977 <br />
                        Support: +91 9600414760
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="col-lg-6 career_jobinteam col-xl-6"
                  data-wow-delay="0.3s"
                >
                  <div className="d-flex">
                    <div className="ps-4">
                      <div className="service-btn text-center p-3">
                        <p className="text-white mb-0">STONE</p>
                        <h3 className="text-white stonenum">4</h3>
                      </div>
                    </div>
                    <div class="service-content p-3 pt-0  text-start">
                      <a href="#" class="h6 d-inline-block text-white mb-3">
                        BNR Cogniitec Private Limited
                      </a>
                      <p className="text-white mb-0">
                        53-2, Second Floor, MKP Colony Main St, Ganapathy,
                        Coimbatore, Tamil Nadu-641006.
                      </p>
                      <p className="text-white mb-0">info@cogniitec.com</p>
                      <p className="text-white mb-0">
                        Office: 0422 4512662 <br />
                        Support: +91 6380750902
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Corporateoffice;
